import {Component, OnDestroy, OnInit} from '@angular/core';
import {Observable, Subscription} from "rxjs";
import {
  SocialGroups
} from "../../../../../store/entities/citizens/citizens-services-category/citizens-services-category.model";
import {environment} from "../../../../../../environments/environment";
import {Store} from "@ngrx/store";
import {AppState} from "../../../../../store/reducers";
import {ActivatedRoute} from "@angular/router";
import {citizenGetServices} from "../../../../../store/entities/citizens/citizens-services/citizens-services.actions";
import {enumToObjectArray} from "../../../../../shared/functions/functions";
import {ServiceClusterEnumTranslate} from "../../../../../interfaces/global.interface";
import {
  CitizensServicesSector
} from "../../../../../store/entities/citizens/citizens-services-sector/citizens-services-sector.model";
import {
  citizenGetAllSectors
} from "../../../../../store/entities/citizens/citizens-services-sector/citizens-services-sector.actions";
import {
  selectModifiedCitizenSector
} from "../../../../../store/entities/citizens/citizens-services-sector/citizens-services-sector.selectors";
import {
  selectModifiedInstitution
} from "../../../../../store/entities/system-settings/institution/institution.selectors";
import {getAllInstitutions} from "../../../../../store/entities/system-settings/institution/institution.actions";
import {Institution} from "../../../../../store/entities/system-settings/institution/institution.model";

@Component({
  selector: 'app-services-by-service-groups',
  templateUrl: './services-by-service-groups.component.html',
  styleUrl: './services-by-service-groups.component.scss'
})
class ServicesByServiceGroupsComponent implements OnInit, OnDestroy {
  title: string;
  fileServer: string = environment.FILE_SERVER_URL
  pageHolder: { itemsPerPage: number, pageNumber: number } = {itemsPerPage: 18, pageNumber: 1};
  activeTab: any;
  citizenSectors$: Observable<CitizensServicesSector []>;
  institutions$: Observable<Institution[]>


  specialNeedsOptions = enumToObjectArray(SocialGroups);
  ServiceClusterEnumOptions = enumToObjectArray(ServiceClusterEnumTranslate);
  tabOpen = true;
  selectedCategory: 'Special_Needs' | 'Elderly' | 'Women' | 'Children' | 'G2F' | 'sector' | 'G2B' | 'institution';
  routeSub = Subscription.EMPTY;
  querySub = Subscription.EMPTY;
  keyword: string;
  searchKeyWord: string;

  constructor(
    private readonly store: Store<AppState>,
    private readonly activatedRoute: ActivatedRoute
  ) {
  }

  ngOnInit() {

    this.title = 'Service Categories';
    this.citizenSectors$ = this.store.select(selectModifiedCitizenSector);
    this.institutions$ = this.store.select(selectModifiedInstitution);


    if (this.activatedRoute.snapshot?.data['from'] === 'SpecialGroup') {
      this.routeSub = this.activatedRoute.paramMap.subscribe(items => {
        this.selectedCategory = 'Special_Needs'
        this.activeTab = items.get('group') as any;
        this.getLeftSideOptions();
        this.loadNextData();
      });
    } else {
      this.routeSub = this.activatedRoute.paramMap.subscribe(items => {
        this.selectedCategory = items.get('categoryUniqueId') as any;
        this.activeTab = this.selectedCategory;
        this.getLeftSideOptions();
        this.applyInstitutionQueryParam();
        this.loadNextData();
      });
    }

    this.querySub = this.activatedRoute.queryParamMap.subscribe(params => {
      const institutionUniqueId = params.get('institutionUniqueId');
      if (institutionUniqueId && this.selectedCategory === 'institution') {
        this.activeTab = institutionUniqueId;
        this.loadNextData();
      }
    });
  }

  private applyInstitutionQueryParam() {
    const institutionUniqueId = this.activatedRoute.snapshot.queryParamMap.get('institutionUniqueId');
    if (institutionUniqueId && this.selectedCategory === 'institution') {
      this.activeTab = institutionUniqueId;
    }
  }

  searchData(value: string) {
    this.keyword = value;
    this.getLeftSideOptions();
  }


  getLeftSideOptions() {
    switch (this.selectedCategory) {
      case "institution":
        this.store.dispatch(getAllInstitutions({
          few: true,
          filtering: {
            pageNumber: 1,
            itemsPerPage: 20,
            keyword: this.keyword
          }
        }))
        break;
      case "sector":
        this.store.dispatch(citizenGetAllSectors({filtering: this.keyword}));
        break;
      case "Special_Needs":
        break;
      case "G2B" || "G2F":

        break;
    }
  }


  loadNextData() {
    switch (this.selectedCategory) {
      case "institution":
        this.store.dispatch(citizenGetServices({
          filtering: {
            ...this.pageHolder,
            institutionUniqueId: this.activeTab,
            keyword: this.searchKeyWord
          },
          showFew: true
        }));
        break;
      case "sector":
        this.store.dispatch(citizenGetServices({
          filtering: {
            ...this.pageHolder,
            sectorUniqueId: this.activeTab,
            keyword: this.searchKeyWord
          },
          showFew: true
        }));
        break;
      case "Special_Needs":
        this.store.dispatch(citizenGetServices({
          filtering: {
            ...this.pageHolder,
            socialGroup: [this.activeTab],
            keyword: this.searchKeyWord
          },
          showFew: true
        }));
        break;
      case "G2B":
      case "G2F":
        this.store.dispatch(citizenGetServices({
          filtering: {
            ...this.pageHolder,
            consumerGroup: [this.activeTab],
            keyword: this.searchKeyWord
          },
          showFew: true
        }));
        break;

      default:
        this.store.dispatch(citizenGetServices({
          filtering: {
            ...this.pageHolder,
            socialGroup: [this.activeTab],
            keyword: this.searchKeyWord
          },
          showFew: true
        }));
        break;
    }

  }

  paginate(pageable: any) {
    this.pageHolder = {...this.pageHolder, pageNumber: pageable?.pageNumber};
    this.loadNextData();
  }

  onTabSelect(value) {
    this.activeTab = value;
    this.loadNextData();
  }

  onSearch(searchKey: string) {
    this.searchKeyWord = searchKey;
    this.loadNextData();
  }


  ngOnDestroy() {
    this.routeSub.unsubscribe();
    this.querySub.unsubscribe();
  }

}

export default ServicesByServiceGroupsComponent
